export enum ToolChainInstanceStatus {
    PENDING = 'Ausstehend',
    SUCCESS = 'Erfolgreich',
    WORKING = 'Laufend',
    FAILED = 'Fehler',
    FINISHED = 'Beendet'
}
